import { MenuItem as MenuItemMUI } from '@mui/material';
import { ReactNode } from 'react';
import { NavLink } from 'react-router';

export type MenuItemProps = {
  children?: ReactNode;
  className?: string;
  component?: React.ElementType;
  to?: string;
  onClick?: () => void;
};

export const MenuItem = ({
  className,
  component,
  to,
  children,
  onClick,
}: MenuItemProps) => {
  return (
    <MenuItemMUI
      disableRipple
      className={className}
      component={component ?? NavLink}
      to={to}
      onClick={onClick}
    >
      {children}
    </MenuItemMUI>
  );
};
